'use client';

import { useEffect, useState } from 'react';
import { getSafeInsets } from '@/utils/browser';
import { useDocumentVisibility } from 'ahooks';

export default function SafeareaEffect() {
  const [bottomSafe, setBottomSafe] = useState(0);
  const getSafeInsetsData = async () => {
    try {
      const { bottomSafe } = await getSafeInsets();
      setBottomSafe(bottomSafe || 0);
    } catch (error) {
      console.error('Failed to get safe insets:', error);
      // 如果获取安全区域失败，使用默认值
      setBottomSafe(0);
    }
  };
  useEffect(() => {
    getSafeInsetsData();
  }, []);

  useEffect(() => {
    // 不再设置 body 高度，让内容自然流动以支持 body 滚动
    // 底部安全区域通过 padding-bottom 处理
    if (bottomSafe > 0) {
      document.body.style.paddingBottom = `${bottomSafe}px`;
    }
    return () => {
      document.body.style.paddingBottom = '';
    };
  }, [bottomSafe]);

  const documentVisibility = useDocumentVisibility();
  useEffect(() => {
    if (documentVisibility === 'visible') {
      getSafeInsetsData();
    }
  }, [documentVisibility]);

  return null;
}